import React from 'react';
import PropTypes from 'prop-types';
import {configuredRadium} from '../../utils/General';

const styles = {
    wrapper: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        maxHeight: '200px',
        overflow: 'auto'
    },
    chatService: {
        fontSize: '16px',
        textAlign: 'center',
    },
    chatServiceActive: {
        color: '#09183A',
    },
    chatServiceInactive: {
        color: '#DDE4F6',
    },
};


const FeatureList = ({
                         features
                     }) => {


    return (
        <ul style={styles.wrapper} className={"no-style-list"}>
            {features.map(f => (
                <div key={f.title.en} style={{display: 'flex', gap: '20px', marginBottom: '10px'}}>
                    <span style={styles.checkbox}>✔</span>
                    <li className={"chatServiceItem"}>{f.title.en}</li>
                </div>
            ))}
        </ul>
    );
};


FeatureList.propTypes = {
    features: PropTypes.array.isRequired,
};
export default configuredRadium(FeatureList);



// WEBPACK FOOTER //
// ./src/components/tariff/FeatureList.jsx